import { Component, inject } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-newsletter-subscribe',
    templateUrl: './newsletter-subscribe.component.html',
    styleUrls: ['./newsletter-subscribe.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgStyle]
})
export class NewsletterSubscribeComponent {

  private accountService = inject(AccountService);
  private notificationService = inject(NotificationService);

  subscribeEmail = new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9._%+-]{2,}[.][A-Za-z]{2,}$')]);
  hasClickOnSubscribe = false;

  onSubmitSubscribe() {
    this.hasClickOnSubscribe = true;
    if (this.subscribeEmail.invalid) { this.getErrorMessage(); return; }
    const email = this.subscribeEmail.value != null ? this.subscribeEmail.value : "";
    this.accountService.subscribeMailToNewsLetter(email)
      .subscribe(
        () => {
          this.notificationService.success('You have successfully subscribed to the newsletter');
        },
        (error) => {
          let errorstr = "Failed subscribing to newsletter: ";
          errorstr += this.accountService.getErrorStr(error.status);
          this.notificationService.error(errorstr);
        }
      );
  }

  getErrorMessage() {
    if (this.subscribeEmail.hasError('required')) {
      return 'You must enter a valid email';
    }
    return this.subscribeEmail.hasError('email') ? 'Not a valid email' : '';
  }

}
